/** @format */

import EntityTag from '@atoms/EntityTag';
import InfiniteScrollList from '@atoms/InfiniteScrollList';
import Input from '@atoms/Input';
import PrefixedInput from '@atoms/PrefixedInput';
import { Tag } from '@common/model/apiClient/Tag';
import { TagCategory } from '@common/model/apiClient/TagCategory';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { SetStateAction } from 'react';
import styled from 'styled-components';

export type TagWithCategory = Tag & { category: TagCategory };

interface TagMenuProps {
  tags: Array<TagWithCategory>;
  search: string;
  setSearch: React.Dispatch<SetStateAction<string>>;
  fetchNext(): void;
  id: string;
  hasMore: boolean;
  icon: IconName;
  onSelect(tag: TagWithCategory): void;
}

const StyledTagMenu = styled.div`
  border: 1px solid var(--grey-100);
  border-radius: 3px;
  padding: 4px;
  background: var(--grey-100);
  box-sizing: border-box;
  width: 100%;
`;

function TagMenu(props: TagMenuProps) {
  return (
    <StyledTagMenu>
      <PrefixedInput icon={<FontAwesomeIcon icon={['far', 'search']} />}>
        <Input onChange={(value) => props.setSearch(value)} value={props.search} />
      </PrefixedInput>
      <InfiniteScrollList id={props.id} fetchNext={props.fetchNext} hasMore={props.hasMore} dataLength={props.tags.length}>
        {props.tags.map((tag) => (
          <EntityTag
            category={tag.category?.name}
            style={tag.category.style}
            key={tag.id + tag.label}
            label={tag.label}
            button={props.icon}
            onClick={() => {
              props.onSelect(tag);
            }}
          />
        ))}
      </InfiniteScrollList>
    </StyledTagMenu>
  );
}

export default TagMenu;
